import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initDevTools } from './devtools/initDevTools';
import { purgeLegacySentRelanceCache } from './utils/relance/purgeLegacySentRelanceCache';
import './index.css';
import './i18n/i18n';

// Before render, so the overlay's console/network capture is in place for the first frame.
initDevTools();
purgeLegacySentRelanceCache();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
